<template>
    <div>
        <section id="fun-facts" class="vc_row">
            <div class=" col-md-6 vc_col section-padding dark-bg ">
                <div class="fact_m white-text">
                    <h2>Porqué <span>Elegirnos</span></h2>
                    <ul>
                        <li>
                            <i class="fa fa-calendar" aria-hidden="true"></i>
                            <h2>10+</h2>
                            <p>Años en el Mercado</p>
                        </li>

                        <li>
                            <i class="fa fa-car" aria-hidden="true"></i>
                            <h2>2000+</h2>
                            <p>Vehículos Vendidos</p>
                        </li>

                        <li>
                            <i class="fa fa-car" aria-hidden="true"></i>
                            <h2>3000+</h2>
                            <p>Consignaciones</p>
                        </li>

                        <li>
                            <i class="fa fa-user" aria-hidden="true"></i>
                            <h2>3500+</h2>
                            <p>Clientes Satisfechos</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class=" col-md-6 vc_col section-padding">
                <div class="facts_section_bg"></div>
            </div>
        </section>
        <section id="about_us" class="section-padding gray-bg">
            <div class="container">
                <div class="section-header text-center">
                    <h2>Nuestros Valores</h2>
                </div>

                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="about_info">
                            <div class="icon_box">
                                <i class="fa fa-thumbs-o-up" aria-hidden="true"></i>
                            </div>
                            <h5>Calidad en el servicio</h5>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="about_info">
                            <div class="icon_box">
                                <i
                                    class="fa fa-history"
                                    aria-hidden="true"
                                ></i>
                            </div>
                            <h5>Agilidad</h5>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="about_info">
                            <div class="icon_box">
                                <i class="fa fa-money" aria-hidden="true"></i>
                            </div>
                            <h5>Efectividad</h5>
                        </div>
                    </div>

                    <div class="col-md-3 col-sm-6">
                        <div class="about_info">
                            <div class="icon_box">
                                <i class="fa fa-users" aria-hidden="true"></i>
                            </div>
                            <h5>Confiabilidad</h5>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
